import { gql } from '@apollo/client'

export const BEGIN_REVIEW_EDIT_CORRECTION = gql`
  mutation BeginReviewEditCorrection($boxId: ID!) {
    beginReviewEditCorrection(boxId: $boxId) {
      __typename
      ... on ClassificationCorrection {
        crop {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          isHumanAdded
          isHumanDeleted
          isFlagged
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
          verifiedUpc
          currentUpc
          leasedById
          leasedAt
        }
        candidates {
          id
          upcA
          name
          brandName
          marketingImageUrl
          packaging
        }
        image {
          id
          imageUrl
        }
      }
      ... on LeaseLockError {
        code
        message
        retryAfterMs
      }
      ... on NoItemsAvailableError {
        code
        message
      }
    }
  }
`
